import { request as httpRequest } from './http-library.js';
import publicConfig from '../public-config.js';

const reviewHost = publicConfig.external_address;

// private

function _readReviews (path, token, callback) {
  const params = {
    host: reviewHost,
    method: 'GET',
    path: `/v1/reviews/${path}`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
  httpRequest(params, function (res) {
    callback(res);
  });
}

function _updateReview (reviewId, token, payload, callback) {
  const params = {
    host: reviewHost,
    method: 'PUT',
    path: `/v1/reviews/${reviewId}`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
  httpRequest(params, function (res) {
    callback(res);
  }, payload);
}

// public
const Reviews = {

  /**
   *
   * @function
   * @name get review
   * @param {String}   - path string
   * @param {String}   - Access token (retrived from sessions)
   * @param {Function} - Callback
   */

  read: (path, token, callback) => {
    const readReviews = _readReviews(path, token, callback);
    return readReviews;
  },

  /**
   *
   * @function
   * @name get review
   * @param {String}   - reviewId string
   * @param {String}   - Access token (retrived from sessions)
   * @param {Object}   - payload
   * @param {Function} - Callback
   */

  update: (reviewId, token, payload, callback) => {
    const updateReview = _updateReview(reviewId, token, payload, callback);
    return updateReview;
  }
};

export default Reviews;
